import { Record } from 'immutable';
import { MODEL_YEARS } from 'build-and-quote/constants/sections.js';
import config from 'build-and-quote/config/index.js';

const BuildAndQuoteRecord = Record({
    buildAndQuoteSection: MODEL_YEARS.value,
    mobilePaymentCalculatorOpened: false,
    imageServer: {
        imageServerDomain: config.source.image,
        imageServerFullSize: '/images/newcar/',
        imageServerBreadcrumb: '/ir/w120h50c/images/newcar/',
        imageServerRelative: '/ir/w960h450c/images/newcar/',
        imageServerSummaryRelative: '/ir/w640h333c/images/newcar/',
        imageServerSummaryOverview: '/ir/w420h280c/images/newcar/',
        imageThumbnailRelative: '/ir/w100h50c/images/newcar/',
        imageExteriorColorsRelative: '/images/newcar/colors/',
        imageInteriorColorsRelative: '/images/newcar/colors/clothes/',
        placeholderImageUrl: '',
    },
});

class BuildAndQuote extends BuildAndQuoteRecord {}

export default BuildAndQuote;
